import React from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
/**
 * Status: *finished*.
 * Category: PageElements
 *
 * The PageFooter is the main footer on the page, and should be included only once.
 * It contains a small number of important, side-wide links.
 */

var PageFooter = function PageFooter(_ref) {
  var links = _ref.links,
      specialLink = _ref.specialLink;
  return /*#__PURE__*/React.createElement("footer", {
    className: "page-footer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page-footer__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page-footer__content-wrapper"
  }, /*#__PURE__*/React.createElement("nav", {
    className: "page-footer__main-nav"
  }, map(links, function (link, i) {
    return /*#__PURE__*/React.createElement("a", {
      key: i,
      className: "page-footer__link",
      href: link.url
    }, link.text);
  })), /*#__PURE__*/React.createElement("nav", {
    className: "page-footer__special-nav"
  }, /*#__PURE__*/React.createElement("a", {
    className: "page-footer__special-link page-footer__link",
    href: specialLink.url
  }, specialLink.text)))));
};

PageFooter.propTypes = {
  links: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
  })),
  specialLink: PropTypes.shape({
    text: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
  })
};
export default PageFooter;